import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import fetchListings from '../../models/Integration/fetchListings'

function* getListings(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchAirbnbListings)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, fetchListings)),
    ])

    const listings = yield call(service)

    yield Effects.put({
      type: IntegrationAction.AcceptListings,
      payload: listings.items,
    })
  } catch (e) {
    yield Effects.put({
      type: IntegrationAction.AcceptListings,
      payload: [],
    })
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.GetListings, getListings)
}
